<template>
  <td>
    <div>{{ user.first_name }}</div>
  </td>
  <td>
    <div>{{ user.last_name }}</div>
  </td>
  <td>
    <div>{{ user.email }}</div>
  </td>
  <td>
    <div>{{ user.telephone }}</div>
  </td>
  <td>
    <div>{{ user.user_type?.name || "—" }}</div>
  </td>
  <td>
    <div>{{ user.comunidad?.name }}</div>
  </td>
  <td>
    <div>{{ new Date(user.dateCreated).toLocaleDateString("es-ES") }}</div>
  </td>
  <td class="text-center" style ="width: 50px;">
    <button
      class="btn btn-sm btn-outline-danger"
      data-bs-toggle="modal"
      :data-bs-target="'#modalEditUser' + id"
    >
      <i class="fas fa-edit"></i>
    </button>
  </td>

  <!-- Modal Edit User -->
  <div
    class="modal fade"
    :id="'modalEditUser' + id"
    tabindex="-1"
    aria-labelledby="modalEditUser"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-fullscreen-lg-down">
      <div class="modal-content">
        <form @submit="update">
          <div class="modal-header">
            <h5 class="modal-title">Editar usuario</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <div class="form-group mb-3">
              <label class="form-label">Nombre</label>
              <input
                type="text"
                class="form-control"
                v-model="updateUser.first_name"
              />
            </div>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label class="form-label">Apellidos</label>
              <input
                type="text"
                class="form-control"
                v-model="updateUser.last_name"
              />
            </div>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                v-model="updateUser.email"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              :id="'submitBtn' + id"
              type="submit"
              class="btn btn-primary"
            >
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";

// import Swal from 'sweetalert2'

export default {
  name: "UserRow",
  props: {
    user: Object,
  },
  data() {
    return {
      id: this.user.id,
      updateUser: {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
      },
    };
  },
  methods: {
    async update(evt) {
      evt.preventDefault();
      window.$("#submitBtn" + this.id).empty();
      window
        .$("#submitBtn" + this.id)
        .append(
          '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Guardando'
        );
      let response = await UserService.updateUser(
        this.user.id,
        this.updateUser
      );
      window.$("#submitBtn" + this.id).empty();
      window.$("#submitBtn" + this.id).append("Guardar");
      if (response.status == 200) {
        (this.name = this.updateUser.name),
          window.$("#modalEditUser" + this.id).modal("hide");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Se ha guardado correctamente.",
          showConfirmButton: false,
          timer: 1500,
          backdrop: false,
          toast: true,
        });
      }
    },
  },
};
</script>

<style scoped>
td {
  font-size: 14px;
}
</style>